export const FETCH_GOLD_DEPOSITS_START = "FETCH_GOLD_DEPOSITS_START";
export const FETCH_GOLD_DEPOSITS_SUCCESS = "FETCH_GOLD_DEPOSITS_SUCCESS";
export const FETCH_GOLD_DEPOSITS_ERROR = "FETCH_GOLD_DEPOSITS_ERROR";